<style scoped>
    .main{
        padding-top: .98rem;
    }
    .content{
        padding: .24rem;
    }
    .box{
        background: #fff;
        padding: .24rem;
        margin-bottom: .2rem;
        display: flex;
        align-items: center;
        flex-direction: column;
        border-radius: .1rem;
    }
    .top{
        width: 6.43rem;
        height: 2.73rem;
        background: url("~assets/battery.png") no-repeat center/cover;
        position: relative;
    }
    .scoreBox{
        position: absolute;
        right: .8rem;
        bottom: .4rem;
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    .score{
        margin-bottom: .24rem;
        font-size: .24rem;
        color: #0D74CF;
    }
    .score span{
        font-size: .48rem;
    }
    .assessTitle{
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: .3rem;
        color: #2484D8;
        font-weight: bold;
        margin: .35rem 0;
    }
    .assessTitle span{
        margin: 0 .15rem;
    }
    .assessLeft{
        width: .78rem;
        height: .04rem;
        background: url("~assets/assessLeft.png") no-repeat center/cover;
    }
    .assessRight{
        width: .78rem;
        height: .04rem;
        background: url("~assets/assessRight.png") no-repeat center/cover;
    }

    #myChart{
        width: 100%;
        height: 4.5rem;
    }

    .lastTitle{
        width: 100%;
        font-size: .3rem;
        color: #000;
        margin-bottom: .2rem;
    }

    .lastContent{
        width: 100%;
        font-size: .28rem;
        color: #676767;
        line-height: .4rem;
    }

    .btn{
        background: #369AF0;
        width: 2.6rem;
        height: .8rem;
        border-radius: .4rem;
        font-size: .3rem;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: .4rem auto;
    }
</style>
<template>
    <div class="main">
        <topbar text="查看报告"></topbar>
        <div class="content">
            <div class="box">
                <div class="top">
                    <div class="scoreBox">
                        <div class="score">
                            <span>{{score}}</span>分</div>
                        本次测评总得分
                    </div>
                </div>
                <div class="assessTitle">
                    <div class="assessLeft"></div>
                    <span>总体性评估</span>
                    <div class="assessRight"></div>
                </div>
                <div id="myChart"></div>
            </div>
            <div class="box">
                <div class="lastTitle">测试结果：</div>
                <div class="lastContent">{{testResult}}</div>
            </div>

            <div class="btn" @click="to(`mentalExperience?comboId=${comboId}`)">返回心理体检</div>
        </div>

    </div>
</template>
<script>
    import {getSource, getSources} from "../api"

    import noMoreData from 'components/no-more-data'
    import topbar from 'components/topbar'
    import moment from 'moment/moment'
    import echarts from 'echarts'

    import {Swiper, Slide} from 'vue-swiper-component';
    import {serialize} from 'utils/index'

    export default {
        data() {
            return {
//                EnvUrl: `https://oml9ntix5.qnssl.com/`, // 七牛图片
                EnvUrl: `https://cdn.ysqingxin.com/`,
                status:false,
                status2:false,
                comboId:this.$route.query.comboId?this.$route.query.comboId:'',
                score:'',
                testResult:'',
                valueList:[],
                keyList:[],
            }
        },
        components: {
            noMoreData,
            topbar,
            Swiper,
            Slide,
        },
        filters: {
            time(value) {
                let transTime = moment(value).format('YYYY-MM-DD HH:mm:ss')
                return transTime
            },
        },
        computed: {},
        methods: {
            async setEcharts(){
                let myChart = echarts.init(document.getElementById('myChart'));
                let option = {
                    tooltip: {},
                    xAxis: {
                        data: [...this.keyList]
                    },
                    yAxis: {
                        splitNumber: 2 ,
                        // axisLabel:{
                        //     formatter: function (value) {
                        //         var texts = [];
                        //         if(value<=20){
                        //             texts.push('轻度');
                        //         }
                        //         else if (value<=40&&value>20) {
                        //             texts.push('中度');
                        //         }
                        //         else if (value>40) {
                        //             texts.push('重度');
                        //         }
                        //         return texts;
                        //     }
                        // },
                        // data: ["轻度","中度","重度"]
                    },
                    series: [{
                        name: '程度',
                        type: 'bar',
                        barWidth: '30%',
                        data: [...this.valueList],
                        //配置样式
                        itemStyle: {
                            //通常情况下：
                            normal:{
                                //每个柱子的颜色即为colorList数组里的每一项，如果柱子数目多于colorList的长度，则柱子颜色循环使用该数组
                                color: function (params){
                                    var colorList = ['#FF7B7D','#FFC387','#F5BD95','#6FC7EC'];
                                    return colorList[params.dataIndex];
                                },
                                barBorderRadius:[30, 30, 0, 0],
                                label: {
                                    show: true, //开启显示
                                    position: 'top', //在上方显示
                                    textStyle: { //数值样式
                                        color: '#9C9C9C',
                                        fontSize: 14
                                    }
                                }
                            },
                            //鼠标悬停时：
                            // emphasis: {
                            //     shadowBlur: 10,
                            //     shadowOffsetX: 0,
                            //     shadowColor: 'rgba(0, 0, 0, 0.5)'
                            // }
                        },
                    }]
                };
                myChart.setOption(option);
            },
            to(n) {
                this.$router.push(`/${n}`)
            },
            async getScaleGroupComboReport() {
                let data = await getSources("/bear-scale/api/scaleGroup/getScaleGroupComboReport.json",{
                    recordId:this.$route.query.recordId?this.$route.query.recordId:''
                });
                if (data.status === 0) {
                    this.score=data.score;
                    this.testResult=data.testResult;
                    let testRecord=JSON.parse(data.testRecord)
                    for (let i in testRecord) {
                        this.keyList.push(i); //属性
                        this.valueList.push(testRecord[i]); //属性
                    }

                    this.setEcharts()
                }else{
                    alert(data.msg)
                }
            },
        },
        destroyed() {

        },
        mounted() {
            this.getScaleGroupComboReport()
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/correctResult.vue?df91e8e8